import { HiDocumentReport } from 'react-icons/hi';
import { MdRoomPreferences } from 'react-icons/md';
import { TbReportAnalytics } from 'react-icons/tb';
import { TbReport } from 'react-icons/tb';
import { TbFileReport } from 'react-icons/tb';

const tiles = [
  {
    sNo: 1,
    link: '/common/redBinMonitoringSheet/dailyProductionList',
    isLink: true,
    icon: <HiDocumentReport size="5rem" color="#003566" />,
    p: 'RED BIN MONITORING Rejection',
    span: 'Data',
    isIcon: true,
  },
  // {
  //   sNo: 2,
  //   link: '/common/redBinMonitoringSheet/dailyProductionList?documentType=pressShop3&heading=Press Shop 3',
  //   isLink: true,
  //   icon: <HiDocumentReport size="5rem" color="#003566" />,
  //   p: 'PRESS SHOP',
  //   span: '3',
  //   isIcon: true,
  // },
  // {
  //   sNo: 3,
  //   link: '/common/redBinMonitoringSheet/tableList',
  //   isLink: true,
  //   icon: <HiDocumentReport size="5rem" color="#003566" />,
  //   p: 'Rejection Table',
  //   span: 'Data',
  //   isIcon: true,
  // },
  {
    sNo: 4,
    link: '/common/redBinMonitoringSheet/dashboardList',
    isLink: true,
    icon: <MdRoomPreferences size="5rem" color="#003566" />,
    p: 'RED BIN MONITORING REJECTION',
    span: 'DASHBOARD',
    isIcon: true,
  },
  {
    sNo: 19,
    link: `/common/capaAnalysisFormatsUpload/?documentType=capaAnalysisFormatsUpload&heading=CAPA & ANALYSIS FORMATS`,
    isLink: true,
    icon: <HiDocumentReport size="5rem" color="#003566" />,
    p: 'CAPA & Analysis',
    span: 'Formats',
    isIcon: true,
  },
];

export default tiles;
